import {ReactKeycloakProvider} from '@react-keycloak/web';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import React, {useState} from 'react';
import keycloakInstance from '../keycloak';
import '../styles/css/Navigation.scss';
import KeycloakWrapper from './keycloak-wrapper';

const initOptions = {
  onLoad: 'login-required',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
};

const App = () => {
  const [keycloakReady, setKeycloakReady] = useState(false);

  const onKeycloakEvent = (event, error) => {
    if (event && event === 'onReady') {
      setKeycloakReady(true);
    }
  };

  return (
    <ReactKeycloakProvider
      authClient={keycloakInstance}
      initOptions={initOptions}
      onEvent={onKeycloakEvent}
      keycloak={keycloakInstance}
    >
      {keycloakReady && <KeycloakWrapper></KeycloakWrapper>}
    </ReactKeycloakProvider>
  );
};

export default App;
